import { cn } from '@/utils/style.ts'
import { FormFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import React from 'react'
import { useController, useWatch } from 'react-hook-form'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'
import { DatePicker, DatePickerProps } from 'antd'
import dayjs from 'dayjs'

type FormDatePicker2Props = {
  dateFormat?: string
  disabled?: boolean
} & WrappedInputProps

export const FormDatePicker2: React.FC<FormDatePicker2Props> = ({
  name,
  label,
  description,
  className,
  wrapperClassName,
  dateFormat = 'MMMM D, YYYY',
  disabled,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName })
  const value = useWatch({ name: fieldName })
  const onChange: DatePickerProps['onChange'] = (_, dateString) => {
    field.onChange(dateString || undefined)
  }

  const finalValue = !value ? undefined : dayjs(value, dateFormat)
  return (
    <FormFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      disabled={disabled}
      description={description}
    >
      <DatePicker
        className={cn(className)}
        value={finalValue as never}
        format={dateFormat}
        onChange={onChange}
        disabled={disabled}
      />
    </FormFieldWrapper>
  )
}
